import type { GuideKey } from "@/plan-logic/site/guides";

/**
 * Which page guides a user has seen, in this browser's localStorage by Firebase uid
 * (`abi.guidesSeen.<uid>`): there's no backend flag yet, so another browser shows them again.
 * Without a uid (never in the signed-in app) it's kept for this tab only.
 */
const KEY = "abi.guidesSeen.";
const memory = new Set<string>();

function read(uid: string): string[] {
  try {
    const v: unknown = JSON.parse(localStorage.getItem(KEY + uid) ?? "[]");
    return Array.isArray(v) ? v.filter((x): x is string => typeof x === "string") : [];
  } catch {
    return [];
  }
}

export function wasSeen(uid: string | undefined, page: GuideKey): boolean {
  return uid ? read(uid).includes(page) : memory.has(page);
}

export function markSeen(uid: string | undefined, page: GuideKey): void {
  if (!uid) {
    memory.add(page);
    return;
  }
  const seen = read(uid);
  if (seen.includes(page)) return;
  try {
    localStorage.setItem(KEY + uid, JSON.stringify([...seen, page]));
  } catch {
    // storage full or blocked: the guide shows again next time, which is harmless
  }
}
